export function createElementFromHtml(htmlString) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

export function replaceElement(selectorToReplace, newHtml, newSelector = null) {
  const elementToReplace = document.querySelector(selectorToReplace);
  const parent = elementToReplace.parentNode;
  const temp = document.createElement('div');
  temp.innerHTML = newHtml.trim();
  let newElement = temp.childNodes[0];
  if (newSelector) {
    newElement = newElement.querySelector(newSelector);
  }
  parent.replaceChild(newElement, elementToReplace);
}
